
export const NAME_REDUCER = 'multiCard';

export const PREFIX_ACTIONS = 'multiCard_feature_';


export const PATH_LOADING = {
  getData: `loading.${NAME_REDUCER}.getData`,
};
